const STORAGE_KEY = "payRequestOverviewData";

/**
 * Store pay request overview navigation data in sessionStorage
 * @param {Object} data - Navigation data object containing:
 *   - task_category_mstr_key: string - Single value or comma-separated values (e.g., "123" or "123,456,789")
 *   - provider_id: string
 *   - status: string - Status filter (e.g., "PENDING", "APPROVED", "REJECTED")
 *   - periodFilter: string - Period filter (e.g., "YTD", "Monthly", "Weekly", "Quarterly", "Daily")
 *   - currentMonth: string - ISO string of the current month date (used when periodFilter is "Monthly")
 */
export const setPayRequestOverviewData = (data) => {
  try {
    if (data && typeof data === "object") {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  } catch (error) {
    console.error("Error storing pay request overview data:", error);
  }
};

/**
 * Retrieve pay request overview navigation data from sessionStorage
 * @returns {Object|null} Navigation data object or null if not found
 */
export const getPayRequestOverviewData = () => {
  try {
    const storedData = sessionStorage.getItem(STORAGE_KEY);
    if (storedData) {
      const data = JSON.parse(storedData);
      return data;
    }
    return null;
  } catch (error) {
    console.error("Error retrieving pay request overview data:", error);
    return null;
  }
};

/**
 * Remove pay request overview navigation data from sessionStorage
 */
export const removePayRequestOverviewData = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Error removing pay request overview data:", error);
  }
};
